import { AppProviders, LibraryProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import { ErrorBoundary, Loading, ModalContainer } from "web/components"
import { render, unmountComponentAtNode } from "react-dom"
import { TLOContextProvider } from "web/contexts"
import { useDeal } from "web/hooks/data"
import React, { Suspense } from "react"
import FindComparableDeals from "web/app/Deals/ViewDeal/DealComparables/Deals/FindComparableDeals"

export default class DealsFindComparableDealsController extends Controller {
  static values = {
    basePath: String,
    dealId: Number,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const DealTLOContextProvider = ({ children }) => {
      return (
        <TLOContextProvider subjectType="deal" data={useDeal(this.dealIdValue)}>
          {children}
        </TLOContextProvider>
      )
    }

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <DealTLOContextProvider>
                <ErrorBoundary>
                  <FindComparableDeals baseUrl={this.basePathValue} />
                </ErrorBoundary>
              </DealTLOContextProvider>

              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }
}
